import { Dashboard, Loading } from '@components'
import { ROUTES } from '@constants'
import { generateCO2Data, generateSavingData, getLocalStorage } from '@helpers'
import { useGetDashboardSummary } from '@hooks'
import { Navigate, useLocation } from 'react-router-dom'

const DashboardContainer = () => {
  const location = useLocation()
  const plantId = location.search.substring(1)

  const { isLoading, data } = useGetDashboardSummary(plantId)

  if(data === null) {
    return <Navigate to={ROUTES.DASHBOARD_UNAVAILABLE} />
  }

  const isEng = getLocalStorage('LANGUAGE') === 'en'

  if (isLoading) {
    return <Loading />
  }

  let power = '-'
  if (data.temperature?.typeDeviceDataM) {
    power = data.systemInfo.dcPowerInputMax
  } else if (data.systemInfo?.peakPower) {
    power = data.systemInfo.peakPower
  }

  const co2Reduction = generateCO2Data(data.pvGenerationDay, data.co2)
  const co2ReductionTotal = generateCO2Data(data.pvGenerationTotal, data.co2)
  const totalSavingDay = generateSavingData(data.pvGenerationDay, data.currency)
  const totalSavingLife = generateSavingData(data.pvGenerationTotal, data.currency)
  const Logo = <img className='logo' src={data.logo} alt={data.logo} />

  return (
    data && (
      <Dashboard
        {...data}
        logo={Logo}
        power={power}
        co2Reduction={co2Reduction}
        co2ReductionTotal={co2ReductionTotal}
        plantId={plantId}
        isEng={isEng}
        totalSavingLife={totalSavingLife}
        totalSavingDay={totalSavingDay}
      />
    )
  )
}

export default DashboardContainer
